import {
  styled,
  Card as BaseCard,
  Typography,
  WithTheme,
} from '@material-ui/core'

interface CardProps extends WithTheme {
  borderWidth?: number
}

export const Card = styled(BaseCard)(
  ({ theme, borderWidth = 2 }: CardProps) => ({
    height: '100%',
    width: '100%',
    padding: theme.spacing(3.5, 2, 1.2),
    display: 'flex',
    position: 'relative',
    borderRadius: 20,
    boxSizing: 'border-box',
    zIndex: 1,
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -2,
      content: '""',
      background: 'linear-gradient(180deg, #1070B0 0%, #5DD987 100%)',
      borderRadius: 20,
    },
    '&::before': {
      position: 'absolute',
      top: borderWidth,
      left: borderWidth,
      right: borderWidth,
      bottom: borderWidth,
      zIndex: -1,
      content: '""',
      background: theme.palette.common.white,
      borderRadius: 19,
    },
  })
)

export const Description = styled(Typography)({
  fontSize: 18,
  fontWeight: 400,
  lineHeight: '26px',
})
